import { Grid } from "@trussworks/react-uswds";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { SurveyTriggerContext } from "../../App";
import { CompareContext } from "../../pages/Search/Search";

import { V1Clinic } from "../../types/v1_schemas";
//import { AnalyticsAction, logEvent } from "../../utils/analytics";
import BasicResultDetail from "../ResultDetail/BasicResultDetail";
//import MilesAway from "./MilesAway";
import { AnalyticsAction, logEvent } from "../../utils/analytics";


type ResultCardProps = {
  data: V1Clinic;
  isMobile?: boolean;
};

export default function ResultCard({ data, isMobile }: ResultCardProps) {
  const { selectedCompareProviders, setSelectedCompareProviders } = useContext(CompareContext);
  const location = useLocation();
  const { t } = useTranslation();
  const [enterCard, setEnterCard] = useState(false);

  // Global application state to track trigger events for showing user
  // option to take site survey
  const { incrementTriggerEventCount } = useContext(SurveyTriggerContext);

  const toggleCompareCheckbox = () => {
    const thisProviderIdx = selectedCompareProviders.findIndex(
      (provider:any) => provider.accountId === data.accountId
    );

    const p = [...selectedCompareProviders];
    if (thisProviderIdx > -1) {
      p.splice(thisProviderIdx, 1);
    } else {
      p.push(data);
    }
    setSelectedCompareProviders(p);
  };

  const isSelectedForCompare = !!selectedCompareProviders.find(
    (v1Clinic:V1Clinic) => v1Clinic.accountId === data.accountId
  );

  return (
    <div className={enterCard ? "padding-y-3 padding-x-5 result-card-hover" : "padding-y-3 padding-x-5 result-card-not-active"}
      role='presentation'
      onMouseEnter={() => {setEnterCard(true) }}
      onMouseLeave={() => {setEnterCard(false) }}
      onClick={() => {
        window.location.href = `/result/${data.accountId}`;
      }}
      // Only set id in the desktop list to avoid creating
      // duplicate DOM elements with same id in mobile list
      id={isMobile ? undefined : data.accountId ?? "0"}
    >
      <Grid 
        row
        style={{gap: '17px'}}
        mobile={{ col: true }}
      >
        <div className="display-flex flex-justify" >
          <div className="search-rank" >
            <span >
              {data.searchRank}
            </span>
          </div>
          <Link
            className="usa-link"
            to={`/result/${data.accountId}`}
            state={{ prevSearch: location.search, data }}

            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            onClick={
              // eslint-disable-next-line @typescript-eslint/no-unused-expressions
              () => {incrementTriggerEventCount; 
                logEvent(AnalyticsAction.SelectProviderDetail, {
                  count: 1,
                }); 

                const entryTime = parseInt((sessionStorage.getItem('searchCardEntryTime') ?? '0'), 10);
                const currentTime = Date.now();
                console.log('currentTime is ' + currentTime.toString());

                if (!isNaN(entryTime) && entryTime > 0) {
                  const timeSpent = currentTime - entryTime; // in milliseconds
                  console.log('timeSpent is ' + timeSpent.toString())

                  logEvent(AnalyticsAction.ProviderSearchTime, {
                    timeSpan: timeSpent
                  })

                  // Optional: clear after sending if you want to track only first transition
                  sessionStorage.removeItem('searchCardEntryTime');}
                }
              }
          >
            <h2 className=" nice_font dark_blue margin-top-1 margin-bottom-1" style={{marginLeft: 13, color:'#1A103F'}} >{data.displayName}</h2>
          </Link>
          
        </div>
      </Grid>
      <div className="display-flex flex-justify" style={{ marginLeft: "60px", color:'#4F4F4F'}} >
          <BasicResultDetail result={data} isCondensed={true} />
      </div>
      {/* <Grid
        row
        mobile={{ col: true }}
        className="flex-justify-center tablet:flex-justify flex-align-center"
      >
        <Link
          onClick={incrementTriggerEventCount}
          className="usa-button"
          to={`/result/${data.accountId}`}
          state={{ prevSearch: location.search, data }}
          aria-label={`${t("fullDetail")} ${data.displayName}`}
        >
          {t("fullDetail")} <span className="usa-sr-only">{data.displayName}</span>
        </Link>
        <Checkbox
          id={`compare-${isMobile ? "mobile-" : ""}${data.accountId}`}
          name={`Compare ${data.displayName}`}
          label={t("compareCheckbox")}
          checked={isSelectedForCompare}
          onChange={() => {
            toggleCompareCheckbox();
            logEvent(AnalyticsAction.SelectLocationForCompare);
          }}
          disabled={
            selectedCompareProviders.length > 1 && !isSelectedForCompare
          }
        />
      </Grid> */}
    </div>
  );
}
